/**
 * @file pipes.module.ts
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhoneNumberPipe } from './format-phone/formatPhone.pipe';
import { NullCheckPipe } from './null-check/null-check.pipe';
import { PlaceholderReplacePipe } from './resolve-placeholders/placeholder-replace.pipe';
import { ContactPipe } from './contact-number/contact.pipe';
import { HighlightSearch } from './hightlight-text/highlightText.pipe';
import { SanitizeHtmlPipe } from './sanitize-html/sanitize-html.pipe';

@NgModule({
  declarations: [ContactPipe, PhoneNumberPipe, HighlightSearch, SanitizeHtmlPipe, NullCheckPipe, PlaceholderReplacePipe],
  imports: [CommonModule],
  exports: [ContactPipe, PhoneNumberPipe, HighlightSearch, SanitizeHtmlPipe, NullCheckPipe, PlaceholderReplacePipe],
})
export class PipesModule {}
